import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	somethingWrong: {
		id: 'opsgenie-schedule.components.opsgenie-schedule-component.schedule-error.something-wrong',
		defaultMessage: "Something's gone wrong",
		description: 'Header message when an error occurs.',
	},

	errorLine1: {
		id: 'opsgenie-schedule.components.opsgenie-schedule-component.schedule-error.error-line-1',
		defaultMessage: 'A problem prevented this page from loading.',
		description: 'Description message when something goes wrong.',
	},
	errorNonAdmin: {
		id: 'opsgenie-schedule.components.opsgenie-schedule-component.schedule-error.error-non-admin',
		defaultMessage: 'Try again later or contact your admin for support.',
		description: 'Detailed error message for non admin users',
	},
	errorAdmin: {
		id: 'opsgenie-schedule.components.opsgenie-schedule-component.schedule-error.error-admin',
		defaultMessage: 'Try again later or {link}.',
		description:
			'Detailed error message for admin users. {link} will be replaced at runtime by string with ID "opsgenie-schedule.components.opsgenie-schedule-component.schedule-error.contact-support"',
	},
	contactSupport: {
		id: 'opsgenie-schedule.components.opsgenie-schedule-component.schedule-error.contact-support',
		defaultMessage: 'contact support',
		description:
			'Link text used to replace {link} at runtime in string with ID "opsgenie-schedule.components.opsgenie-schedule-component.schedule-error.error-admin"',
	},
	action: {
		id: 'opsgenie-schedule.components.opsgenie-schedule-component.schedule-error.action',
		defaultMessage: 'Go to Opsgenie',
		description: 'Text of a button to be displayed when something goes wrong.',
	},
});

export default messages;
